import { useContext } from 'react';
import PreQualification from 'src/context/preQualification/preQualificationContext.jsx';

const usePreQualification = () => {
  return useContext(PreQualification);
};

export default usePreQualification;
